import axios from "axios";
import AuthService from "@/services/auth.service";
import router from "@/router/router";

const BASE_URL = process.env.VUE_APP_API_URL + "/";

const Axios = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
  },
  params:
    process.env.VUE_APP_DEBUG_XDEBUG === "true"
      ? { XDEBUG_SESSION: "PHPSTORM" }
      : {},
});

Axios.interceptors.request.use((request) => {
  const url = request.url || "";
  let token;

  if (url.includes("api/planning")) {
    token = localStorage.getItem("planning_auth_token");
  } else {
    token = AuthService.getAuthToken();
  }

  if (null !== token && token) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const isExpired = payload.exp && payload.exp * 1000 < Date.now();

      if (!isExpired) {
        request.headers.Authorization = "Bearer " + token;
      }
    } catch (e) {
      console.error("Failed to parse token:", e);
    }
  }

  return request;
});

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const url = error.config?.url || "URL inconnue";
    const method = error.config?.method || "method inconnue";
    const apiCall = method + " " + url;

    if (
      apiCall.includes("api/planning") ||
      apiCall === "post api/verificpublic/resend-ation-email"
    ) {
      if (error.response?.status === 401 && !apiCall.includes("auth/login")) {
        localStorage.removeItem("planning_auth_token");
        localStorage.removeItem("planning_user_data");
        const current = router.currentRoute.value;
        if (current.name !== "PlanningLogin") {
          router.replace({
            name: "PlanningLogin",
            query: { returnTo: current.fullPath },
          });
        }
      }
      return Promise.reject(error);
    }

    if (error.response === undefined) {
      alert("API Indisponible " + apiCall + " [4001]");
      return Promise.reject(error);
    }

    if (error.response.status === undefined) {
      alert("API Indisponible " + apiCall + " [4002]");
      return Promise.reject(error);
    }

    if (400 === error.response.status) {
      return Promise.reject(error);
    }
    if (
      401 === error.response.status &&
      apiCall === "post authentication_token"
    ) {
      return Promise.reject(error);
    }

    if (401 === error.response.status || 403 === error.response.status) {
      alert("Vous avez été déconnecté, merci de vous reconnecter à nouveau.");
      AuthService.logout();
      return Promise.reject(error);
    }

    console.log(error.response.status + " " + apiCall + " " + error);

    const dashboardRegex = /^get api\/dashboard\/\d+$/;
    const candidacyRegex = /^get api\/user\/\d+\/candidacy$/;
    if (dashboardRegex.test(apiCall) || candidacyRegex.test(apiCall)) {
      let msg =
        "Votre compte utilisateur est en cours de création. \nVeuillez vous reconnecter dans quelques secondes.";
      if (
        error.response.data &&
        error.response.data.message &&
        "NoDataFoundException" === error.response.data.message
      ) {
        msg = "Votre compte a été désactivé. \nVeuillez en recréer un nouveau.";
      }
      alert(msg);
      AuthService.logout();
      return Promise.reject(error);
    }

    alert("API Indisponible " + apiCall + " [4004]");
    return Promise.reject(error);
  }
);

export default Axios;
